import { initializeApp } from "firebase/app";
import { getFirestore } from "firebase/firestore";
import { getAuth } from "firebase/auth";

const firebaseConfig = {
  apiKey: "AIzaSyANMAPrgIUOHrta_owysA9eAM6ZeYRiGAE",
  authDomain: "khayelitsha-youth-choir.firebaseapp.com",
  projectId: "khayelitsha-youth-choir",
  storageBucket: "khayelitsha-youth-choir.firebasestorage.app",
  messagingSenderId: "336404080744",
  appId: "1:336404080744:web:e63270e4dfb7b7b041b3dd",
  measurementId: "G-1F61SQ13V5"
};

const app = initializeApp(firebaseConfig);
const db = getFirestore(app);
const auth = getAuth(app);

export { db, auth };
